import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../theme";

const ProgressBar = ({ totalRespuestas, respuestasCompletadas }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Calcular el porcentaje completado
  const porcentaje = totalRespuestas > 0   ? (respuestasCompletadas / totalRespuestas) * 100 : 0; // Si totalRespuestas es 0, asignar 0%

  
  // Definir el color de la barra según el progreso
  const getProgressColor = () => {
    if (porcentaje < 33) {
      return colors.redAccent[500]; // Menos de 33%
  } else if (porcentaje < 50) {
    return colors.redAccent[400]; // Menos de 50%
  } else if (porcentaje < 66) {
    return colors.yellowAccent[400]; // Menos de 66%
  } else if (porcentaje < 80) {
    return colors.orange[300]; // Menos de 80%
  } else {
    return colors.greenAccent[200]; // 80% y más
  }
  };

  return (
    <Box display="flex" alignItems="center" flexDirection="column" width="100%">
      <Typography variant="h6" sx={{ mb: 2, mt: 2 }}>
        Progreso: {Math.round(porcentaje)}%
      </Typography>
      <Box width="100%" sx={{ position: "relative", mb: 2 }}>
        <LinearProgress
          variant="determinate"
          value={porcentaje}
          sx={{
            height: 10,
            borderRadius: 5,
            backgroundColor: colors.softWhiteAccent[100], // Color de fondo de la barra
            "& .MuiLinearProgress-bar": {
              backgroundColor: getProgressColor(), // Color dinámico según el progreso
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default ProgressBar;
